import { Component } from '@angular/core';

import { LinkConfirmationService } from '../../services/link-confirmation.service';

@Component({
  selector: 'app-link-confirmation-modal',
  templateUrl: './link-confirmation-modal.component.html',
  styleUrls: ['./link-confirmation-modal.component.scss'],
  standalone: false,
})
export class LinkConfirmationModalComponent {
  readonly pendingLink$ = this.linkConfirmationService.pendingLink$;

  constructor(private linkConfirmationService: LinkConfirmationService) {}

  confirm(): void {
    this.linkConfirmationService.confirm();
  }

  cancel(): void {
    this.linkConfirmationService.cancel();
  }
}
